import { Body } from "@sprout/typography";
import useTranslation from "@hooks/use_translation";
import useProfile from "@/queries/use_profile";
import LoadingSpinner from "@/sprout/loading_spinner";
import ProfileBanner from "@components/profile/profile_banner";
import ProfileCallout from "@components/profile/profile_callout";
import ProfileHeader from "@components/profile/profile_header";
import ProfileSections from "@components/profile/profile_sections";

const Profile = () => {
  const { t } = useTranslation("user");
  const { data, isLoading, error } = useProfile();

  const renderHeader = () => {
    if (isLoading) {
      return (
        <div className="flex h-32 items-center justify-center">
          <LoadingSpinner size="medium" />
        </div>
      );
    }

    if (error || !data) {
      return <Body>{t("defaultError")}</Body>;
    }

    return <ProfileHeader profile={data} />;
  };

  return (
    <>
      <ProfileBanner />
      <div className="mx-auto max-w-[1550px] px-6 py-6 md:px-[213px]">
        {renderHeader()}
        <ProfileCallout />
        {data && !isLoading && !error && (
          <div className="pt-6">
            <ProfileSections data={data} />
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;
